module.exports = __webpack_public_path__ + "assets/img/30_714_big.34ad4943.jpg";